import { DestroyRef, inject, Injectable } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NavigationError, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import {
  isStaleChunkError,
  reloadForStaleChunk
} from "src/app/support/stale-chunk-error";

@Injectable()
export class ChunkLoadRecoveryService {
  readonly #router = inject(Router);
  readonly #destroyRef = inject(DestroyRef);

  constructor() {
    this.#router.events
      .pipe(
        filter(
          (event): event is NavigationError => event instanceof NavigationError
        ),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe((event) => {
        if (!isStaleChunkError(event.error)) {
          return;
        }

        reloadForStaleChunk();
      });
  }
}
